<template>
  <div>
    <div class="header bg-gradient-success pb-6 pb-8 pt-5 pt-md-8">

      <h4 class="profile-section-title"><i class="ni ni-badge"></i> تکمیل پروفایل </h4>

    </div>
    <div class="container-fluid mt--7">
      <div class="card card-stats" show-footer-line="true">
        <!---->
        <div class="card-body dashboard-top-status">
          <div id="tabs" class="tabs ">
            <nav>
              <ul>
                <li title="اطلاعات شخصی" :class="{ 'tab-current': tabIndex == 0 }" @click="tabIndex = 0">
                  <a class="icon-profile">
                    <span>اطلاعات شخصی</span>
                  </a>
                </li>

                <li title="اطلاعات تکمیلی" :class="{ 'tab-current': tabIndex == 1 }" @click="tabIndex = 1">
                  <a class="icon-complation">
                    <span>اطلاعات تکمیلی</span></a>
                </li>

                <li title="تغییر کلمه عبور" :class="{ 'tab-current': tabIndex == 2 }" @click="tabIndex = 2">
                  <a class="icon-password">
                    <span>تغییر کلمه عبور</span></a>
                </li>
              </ul>
              <div class="slider">
                <div class="indicator"></div>
              </div>
            </nav>

            <PersonalInfo v-if="tabIndex == 0" />
            <CompletionInfo v-if="tabIndex == 1" />
            <ChangePassword v-if="tabIndex == 2" />
          </div>
          <!-- End tabs -->
        </div>
      </div>

      <!---->
      <!---->
    </div>
  </div>
</template>


<script>
import PersonalInfo from "./PersonalInfo";
import ChangePassword from "./ChangePassword";
import CompletionInfo from "./CompletionInfo";

export default {
  name: "ProfileContent",
  components: {
    PersonalInfo,
    ChangePassword,
    CompletionInfo,
  },
  data: function () {
    return {
      tabIndex: 0,
    };
  },
};
</script>

